const e = document.querySelector('.elite-feature-grid');
if (e) for (let i = 0; i < 5; i++) e.after(e.cloneNode(true));

$(document).on("click",".tab-headings",function() {
  $(".tab-headings").removeClass("active-tab");
  $(this).addClass("active-tab");

  var $target = $(this).data('tab');
  $(".tab-content-wrapper").removeClass("active-content");
  $(`.tab-content-wrapper.${$target}`).addClass("active-content");
});

$(document).on("click",".accordion-title",function() {
  var $this = $(this);
  $this.parent().toggleClass('accordion-wrapper-active');
  $this.toggleClass('accordion-open').next().slideToggle();
  setTimeout(function(){
  },900)
})
$(document).on("click",".accordion-content dt",function() {
 $(this).toggleClass('active-tab').next().slideToggle();
});

$(document).on("click",".mobile-tab-headings",function() {
  $(this).toggleClass("active-content");
});

$(document).on("click",".faqs-accordion-content .tab_name",function() {
 $(this).toggleClass('active-tab').next().slideToggle();
});

$(document).on("click",".product-information-wrapper .tab-content-wrapper dt",function() {
 $(this).toggleClass('active-tab').next().slideToggle();
});

$(document).on("click",".part-payment span",function() {
  $(".buy-now-pay-later").show();
});

$(document).on("click",".x-mas-message-arrow",function() {
 $(this).toggleClass('active').next().slideToggle();
});

$(document).on("click",".buy-now-pay-later .icon-close",function() {
  $(".buy-now-pay-later").hide();
});

$(document).on("change",".price-per-item__container .quantity__input",function() {
    if($(this).val() > 2){
      $('.qty-discount-text').html("Buy 3+, Get 10% off");
    }else if($(this).val() > 1){
      $('.qty-discount-text').html("Buy 3, Get 10% off");
    }else{
      $('.qty-discount-text').html("Buy 2, Get 5% off");
    }
  $("product-form #satcb_quantity").val($(this).val());
  $(".satcb_qty #satcb_quantity").val($(this).val());
  var $form = $(this).attr('form');
  $('#'+$form).find('[type=submit]').attr("unbxdparam_qty",$(this).val());
});
$(document).on("change","#satcb_quantity",function() {
  $(".price-per-item__container .quantity__input").val($(this).val()).change();
});
               
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".price-per-item__container")) {
    setTimeout(() => {
      const price = parseFloat(document.querySelector(".price-per-item__container").getAttribute("data-price"));
      const total_price = price * 2;
      const discount = 0.05;
      const total = (total_price * discount).toFixed(2) / 100;
      $('.calculate-price').html(`Buy 2, Get $${total} off`);
    }, 1000);
  }
});

$(document).on("click", ".product__title .stamped-badge", function () {
  $('html, body').animate({
    scrollTop: $("#stamped-main-widget").offset().top
  }, 1000);
});

$(document).on("click",".footer-block.link_list h2",function() {
  if(window.innerWidth < 750){
    $(this).toggleClass('active');
    $(this).next().toggle();
  }
});

$(document).on("click",".faq-que",function() {
 $(this).toggleClass('active').next().slideToggle();
});

$('.category-option').click(function(){
  var cat = $(this).data('category');
  $('.category-option').removeClass('active');
  $(this).addClass('active');
  if(cat == 'show-all'){
    $('.sub-faq').show();
  }else{
    $('.sub-faq').hide();
    $('.sub-faq[data-type='+cat+']').show();
  }
});

$('#faq-search').keyup(function(){
  var $q = $(this).val().toLowerCase();
    var $targets = $('.faq-wrapper');
    $targets.each(function(){
      var $thiscontent = $(this).text().toLowerCase();
      if ($thiscontent.indexOf($q) > -1) {
        $(this).show();
      }else{
        $(this).hide();
      }
    });
});

function searchFunction() {
  var input, filter, ul, li, s, p, i, txtValue;
  input = document.getElementById('myInput');
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = ul.getElementsByTagName('li');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    p = li[i].getElementsByTagName("p")[0];
    s = li[i].getElementsByTagName("span")[0];
    txtValue = (s.textContent || s.innerText) + " " + (p.textContent || p.innerText) ;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}

function u_decodeAndParse(s) {
  if (s.indexOf('"') === 0) {
    s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
  }
  return u_decodeCookie(s);
}
function u_decodeCookie(s) {
  var pluses = /\+/g;
  return decodeURIComponent(s.replace(pluses, ' '));
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function readCookie(key) {
  // Read
  var cookies = document.cookie.split('; ');
  var result;
  for (var i = 0, l = cookies.length; i < l;i++) {
    var parts = cookies[i].split('=');
    var name = u_decodeCookie(parts.shift());
    var cookie = parts.join('=');
    if(key && key === name) {
      try {
        result = u_decodeAndParse(cookie);
        break;
      } catch (e) {
        this.log(e);
      }
    }
  }
  return result;
}

$(document).on("click",".checkout-btn, #CartDrawer-Checkout-btn",function() {
  $('#CartDrawer-Checkout').prop('disabled', false);
  if($(this).hasClass('direct-to-checkout')){
    $(this).html("Loading Checkout <span class='dot-typing'></span>");
    $("#CartDrawer-Checkout").click();
  }else{
    $('.cart-upsell-overlay').addClass("overlay-show");
    $('.cart-upsell-drawer').addClass("open-drawer");
  }
  resizecart();
});

$(document).on("click",".cart-upsell-overlay, .cart-upsell-header .icon-close, .cart-upsell-footer .go-back-button",function() {
  $('.cart-upsell-overlay').removeClass("overlay-show");
  $('.cart-upsell-drawer').removeClass("open-drawer");
});

$(document).on("click",".whey-freebie-overlay, .whey-freebie-header .icon-close",function() {
  $('.whey-freebie-wrapper').removeClass('open-whey-offer')
  $('.whey-freebie-drawer').removeClass('open-drawer')
  document.body.classList.remove('overflow-hidden');
});

function resizecart(){
 var headerheight = $(".cart-upsell-header").height();
 var footerheight = $(".cart-upsell-footer").height();
 $('.cart-upsell-products').css('height', $(window).height() - headerheight - footerheight - 60 );

 $('.cart-whey-products').css('height', $(window).height() - $(".whey-freebie-header").height());

  // Collection grid banner
 $('.collection-grid-image img').css("max-height",$('.UNX-product-col.UNX-grid-card.product-item').height());
}
resizecart();
$(window).resize(function(){
 resizecart();
});

$(document).on("change",".upsell-variant",function() {
 var regularPrice = $('option:selected',this).attr('the_regular_price');
 var discountedPrice = $('option:selected',this).attr('the_discounted_price');
 var the_discounted_percentage = $('option:selected',this).attr('the_discounted_percentage');
 var the_save_price = $('option:selected',this).attr('the_save_price');
 var $item = $(this).parents('.upsell-item')
 $item.find('.sale_was__price').html(regularPrice);
 $item.find('.sale-new-price').html(discountedPrice);
 $item.find('.discount').html( the_discounted_percentage);
 $item.find('.save-price').html(the_save_price);
 if($('option:selected',this).data('image')){
   $item.find('img').removeAttr('srcset').attr('src',$('option:selected',this).data('image'));
 }
});

$(document).on("click",".UNX-mobile-filter .mob-filter",function() {
 $('.UNX-facet-trigger').trigger('click');
});

$(document).on("click",".UNX-facet-trigger",function() {
 $(this).parents('.UNX-facet-wrapper').find('.UNX-fxd-facet').addClass('show-filter-darwer').parents('.UNX-product-results').addClass('on-overlay');
});

$(document).on("click",".mobile-darwer-close",function() {
 $(this).parents('.UNX-fxd-facet').removeClass('show-filter-darwer').parents('.UNX-product-results').removeClass('on-overlay');
})

$('.tab-content-wrapper img[data-src]').each(function(){
  $(this).attr("src",$(this).data('src'));
});

var EliteWishList = {
  Init: function(){
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }
}
function swymCallbackFn(swat){
  document.addEventListener("swym:collections-loaded", function(){
    swat.initializeActionButtons(".UNX-results-container");
  })
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

function updateTop() {
  const height = document.querySelector('.announcement-bar-section')?.offsetHeight || 0;
  document.documentElement.style.setProperty('--announcement-height', `${height}px`);
}
updateTop();
window.addEventListener('resize', updateTop);


$('.copy-icon-wrapper svg').click(function(){
  var temp = $("<input>");
  var $parents = $(this).parents('.right-content-wrapper');
  $("body").append(temp);
  temp.val($parents.find('strong').text()).select();
  document.execCommand("copy");
  temp.remove();
  $parents.find('.tooltip').fadeIn(500);
  setTimeout(function(){
    $parents.find('.tooltip').fadeOut(500);
  },2000);
});

var eventsTriggered = {
  click: false,
  mousemove: false,
  scroll: false
};

function handleEvents(event) {
  var eventType = event.type;
  if (!eventsTriggered[eventType]) {
      if(window.urls){
        eventsTriggered[eventType] = true;
        for (var i = 0; i < window.urls.length; i++) {
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = window.urls[i];
          var x = document.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        }
      }
  }

  if (eventsTriggered.click || eventsTriggered.mousemove || eventsTriggered.scroll) {
    $(document).off('click mousemove scroll', handleEvents);
  }
}

window.External_Urls = [] || window.External_Urls;

var KlaviyoPriorLoad = false;
var $url = new URL(window.location.href);

if(window.location.pathname == '/pages/get-20-off-at-elite-supplements-the-glen' || window.location.pathname == '/pages/win-10k-worth-of-supps' || window.location.pathname == '/pages/get-15-off-at-elite-supps-penrith' || window.location.pathname == '/pages/perth-warehouse-sale'){
  KlaviyoPriorLoad = true;
}
if($url.searchParams.get("utm_source") == 'google' && $url.searchParams.get("utm_medium") == 'cpc'){
  KlaviyoPriorLoad = true;
}

if(KlaviyoPriorLoad == true){
    var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Qh5vLD";
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
   // KLAVIYO APP BLOCK
   // !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
}else{
  window.External_Urls.push("https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Qh5vLD");
}

function handleEventsForExternal(event) {
    for (var i = 0; i < window.External_Urls.length; i++) {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = window.External_Urls[i];
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }

    if(KlaviyoPriorLoad == false){
     // KLAVIYO APP BLOCK
    // !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
    }

  // IMPACT ANALYTICS
    // (function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://utt.impactcdn.com/A4194594-6054-4c90-8bbf-927db5da91cf1.js','script','ire',document,window);ire('identify');

  // FLOWBOX SCRIPT
    (function(d, id) {
    if (!window.flowbox) { var f = function() { f.q.push(arguments); }; f.q = []; window.flowbox = f; }
    if (d.getElementById(id)) { return; }
    var s = d.createElement('script'), fjs = d.scripts[d.scripts.length - 1]; s.id = id; s.async = true;
    s.src = ' https://connect.getflowbox.com/flowbox.js';
    fjs.parentNode.insertBefore(s, fjs);
    })(document, 'flowbox-js-embed');

    setTimeout(function(){
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = window.floboxJs;
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    },1000);

    // setTimeout(function(){
    //   console.log("inn",$('.kl_reviews__star_rating_widget__label').length)
    //   $('.kl_reviews__star_rating_widget__label').each(function(){
    //     var $thistext = $(this).html();
    //     $(this).html($thistext.replace('ratings',''))
    //   });
    // },2000);

    (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "mixzb1zlpq");

  $(document).off('click mousemove scroll', handleEventsForExternal);
}

$(document).on('click mousemove scroll', handleEvents);
setTimeout(function(){
  $(document).on('click mousemove scroll', handleEventsForExternal);
},3000);

if(window.location.pathname == '/'){
  function executeOnceOnScroll() {
    const scrollThreshold = 1700;
    function onScroll() {
      if (window.scrollY >= scrollThreshold) {
        if(document.getElementsByClassName("klaviyo-featured-review-block")[0]){
          document.getElementsByClassName("klaviyo-featured-review-block")[0].setAttribute("id","klaviyo-featured-reviews-carousel")
        }
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll);
  }
  executeOnceOnScroll();
}

window.update_review = function(){
  const reviewWidgets = document.querySelectorAll('.kl_reviews__star_rating_widget');
  reviewWidgets.forEach(widget => {
    const ariaLabel = widget.getAttribute('aria-label');
    const starRatingMatch = ariaLabel.match(/(\d+(\.\d+)?) stars/);
    const reviewCountMatch = ariaLabel.match(/(\d+) ratings/);
    let starRating = starRatingMatch ? parseFloat(starRatingMatch[1]).toFixed(1) : null;
    const reviewCount = reviewCountMatch ? reviewCountMatch[1] : null;
    if (starRating && (parseFloat(starRating) % 1 === 0)) {
      starRating = parseInt(starRating);
    }
    if (starRating && reviewCount > 0) {
      if (widget.parentNode.querySelectorAll('.reviews__details').length == 0) {
        const reviewContainer = document.createElement('div');
        reviewContainer.classList.add('reviews__details');
        reviewContainer.innerHTML = `<div class="reviews__averange">${starRating}</div><div class="reviews__reviews">(${reviewCount})</div>`;
        widget.parentNode.insertBefore(reviewContainer, widget.nextSibling);
      }
    } else if (reviewCount <= 0 || reviewCount === null){
    }
  });
}

window.update_widget = function(){
  var counter = 0;
  const maxCount = 5;
  const intervalId = setInterval(() => {
    window.update_review();
    counter++;
    if (counter >= maxCount) {
      clearInterval(intervalId);
    }
  }, 1000);
}
window.update_widget();

$(".search-modal__form .unbxd-search").on('keypress keyup', function(){
  if($(this).val().length == 0){
    $('.search-recommend-wrapper').show();
    $('body').addClass('autosuggest_box_open');
  }else{
    setTimeout(function(){
      $('.search-recommend-wrapper').hide();
      $('body').removeClass('autosuggest_box_open');
    }, 100);
  }
});

$(".search-modal__form .unbxd-search").focusin(function() {
  $('.search-recommend-wrapper').show();
  $('body').addClass('autosuggest_box_open');
});

$(document).click(function(event) {
  if (!$(event.target).closest('.search-recommend-wrapper, .header__search').length) {
    $('.search-recommend-wrapper').hide();
    $('body').removeClass('autosuggest_box_open');
  }
});

$('.variant-v2 variant-radios .form__label').click(function(){
  $(this).toggleClass('close-options')
});

$('.quantity-pack-wrapper .qty-v4').click(function(){
  $(this).toggleClass('close-options')
});

// $('.js-variant-nutrition').change(function(){
//     $id = $(this).val();
//     $('.js-variant-nutrition-content').hide();
//     $('.js-variant-nutrition-content[data-variant='+$id+']').show();
// });
$('.js-variant-nutrition').change(function(){
    var $id = $(this).val();
    if($(this).parents('.stack-nips').length){
      $(this).parents('.stack-nips').find('.js-variant-nutrition-content').hide();
      $(this).parents('.stack-nips').find('.js-variant-nutrition-content[data-variant='+$id+']').show();
    }else{
      $(this).parents('.accordion-content').find('.js-variant-nutrition-content').hide();
      $(this).parents('.accordion-content').find('.js-variant-nutrition-content[data-variant='+$id+']').show();
    }
});

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.rounded-collection.slider');
  if (grid) {
    grid.scrollLeft = 0;
  }
  setTimeout(function(){
    if (grid) {
      grid.scrollLeft = 0;
    }
  },2000);
});

$('#gift_popup .close').click(function(){
  $("#gift_popup").hide();
});


const equalizeFeatureBoxHeight = () => {
  const boxes = [...document.querySelectorAll('.ep-feature-box')];
  if (!boxes.length) return;

  boxes.forEach(b => b.style.height = 'auto');

  const maxHeight = Math.max(...boxes.map(b => b.offsetHeight));
  boxes.forEach(b => (b.style.height = `${maxHeight}px`));
};

window.addEventListener('load', equalizeFeatureBoxHeight);
window.addEventListener('resize', equalizeFeatureBoxHeight);

document.addEventListener('click', (e) => {
  // OPEN popup
  if (e.target.closest('.ins-more-info')) {
    const popup = document.querySelector('.ep-info-popup');
    if (!popup) return;

    popup.style.display = 'block';
    equalizeFeatureBoxHeight();
    document.body.classList.add('overflow-hidden');
  }

  // CLOSE popup
  if (e.target.closest('.ep-model-close')) {
    const popup = document.querySelector('.ep-info-popup');
    if (!popup) return;

    popup.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  }
});